import React from 'react';
import './LoadingOverlay.css';

interface Props {
  isLoading: boolean;
  text?: string;
  children: React.ReactNode;
}

const LoadingOverlay: React.FC<Props> = ({ isLoading, text = 'Načítám…', children }) => {
  return (
    <div className={`loading-wrap${isLoading ? ' is-loading' : ''}`} aria-busy={isLoading}>
      {children}
      {isLoading && (
        <div className="loading-overlay" role="status" aria-live="polite">
          <div className="loading-spinner-sm" aria-hidden="true" />
          <div className="loading-overlay-text">{text}</div>
        </div>
      )}
    </div>
  );
};

export default LoadingOverlay;
